import { c as _c } from "react/compiler-runtime";
import { TreatmentsInterestSelectButton } from "@/shared/ui/molecules";
import { Typography } from "@/shared/ui/atoms";
import { useTranslations } from "next-intl";
import { ProcedureItem } from "@/shared/ui/molecules";
import useDataStore from "@/features/home/model/data/store";
const InterestSelectModalBody = () => {
  const $ = _c(9);
  const t = useTranslations();
  const {
    interestTreatment,
    isViewInterestSelectModalIndex
  } = useDataStore();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      key: "dermatology",
      width: 43,
      height: 50
    }, {
      key: "plasticSurgery",
      width: 50,
      height: 48
    }, {
      key: "dentistry",
      width: 45,
      height: 49
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const treatmentList = t0;
  if (isViewInterestSelectModalIndex === 0) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex gap-2">{treatmentList.map(_temp)}</div>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== interestTreatment || $[3] !== t) {
    let t2;
    if ($[5] !== t) {
      t2 = (treatment_0, index_0) => {
        const interestList = t.raw(`commonMedicalTreatment.interestList.${treatment_0}`) as Array<Record<string, string>>;
        const treatmentName = t.raw(`commonMedicalTreatment.treatments.${treatment_0}`) as string;
        return <div key={`procedure-list-${index_0}`}><Typography size={15} lineHeight={24} className="my-[10px] font-semibold tracking-[-0.3px]">{treatmentName}</Typography><ProcedureItem treatmentKey={treatment_0} interestList={interestList} /></div>;
      };
      $[5] = t;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = interestTreatment.map(t2);
    $[2] = interestTreatment;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div>{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default InterestSelectModalBody;
function _temp(treatment, index) {
  return <TreatmentsInterestSelectButton key={`treatment-item-button-${index}`} treatmentKey={treatment.key} width={treatment.width} height={treatment.height} />;
}